import { render, staticRenderFns } from "./veneers-table.vue?vue&type=template&id=0e256de8&scoped=true"
import script from "./veneers-table.vue?vue&type=script&lang=js"
export * from "./veneers-table.vue?vue&type=script&lang=js"
import style0 from "./veneers-table.vue?vue&type=style&index=0&id=0e256de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e256de8",
  null
  
)

export default component.exports